import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
    en:{
        emailInvalid: 'Email address invalid',
        passwordShort: "Password must have at least %{count} characters",
        usernameShort: "Your username must have at least %{count} characters",
        confirmPasswordNotEqual: "The password confirmation must be the same as your password",
    },
    fr:{
        emailInvalid: "L'addresse mail n'est pas valide",
        passwordShort: "Le mot de passe doit avoir au moins %{count} caractères",
        usernameShort: "Votre nom d'utilisateur doit avoir au moins %{count} characters",
        confirmPasswordNotEqual: "La confirmation de mot de passe doit être pareil que votre mot de passe",
    }
})

export default strings